import React, { useRef, useEffect, useState } from 'react';
import loadable from '@loadable/component';
import { compose } from '@/utils/story-composer';
import { ViewportEnum } from '@/enums/viewport-sizes';
import Button from './button';
import PointRight from '../icons/point-right';
import PointLeft from '../icons/point-left';

const Slider = loadable(() => import('react-slick'), { ssr: true });

function Carousel({
	content,
	heading,
	buttons,
	slidesToShow = 3,
	centerPadding = '20px',
	autoplay = false,
	autoplaySpeed = 2000,
	infinite = false,
}) {
	const sliderRef = useRef();
	const buttonNext = useRef();
	const buttonPrev = useRef();

	const [setting, setSetting] = useState({});
	const settings = {
		dots: true,
		arrows: false,
		centerMode: true,
		centerPadding: '8px',
		infinite,
		slidesToShow: Number(slidesToShow),
		autoplay,
		lazyLoad: true,
		autoplaySpeed: Number(autoplaySpeed),
		speed: 800,
		responsive: [
			{
				breakpoint: ViewportEnum.MD,
				settings: {
					slidesToShow: 1,
					dots: true,
					centerMode: true,
					centerPadding,
				},
			},
		],
	};

	const gotoNext = () => {
		sliderRef.current.slickNext();
	};

	const gotoPrev = () => {
		sliderRef.current.slickPrev();
	};

	useEffect(() => {
		setSetting(settings);
		buttonNext.current.style.marginLeft = `${content.length * 1.1}rem`;
		buttonPrev.current.style.marginRight = `${content.length * 1.1}rem`;
	}, [slidesToShow, centerPadding, autoplay, autoplaySpeed, infinite, content]);

	return (
		<div className="col-span-6 w-full md:container my-20">
			{heading && (
				<div className="prose md:prose-md 2xl:prose-2xl 3xl:prose-3xl mb-10 text-center">
					<h2>{heading}</h2>
				</div>
			)}

			<Slider ref={sliderRef} {...setting}>
				{Array.isArray(content) &&
					content.map(sliderItem => (
						<div key={sliderItem} className="px-2 lg:px-4">
							{sliderItem}
						</div>
					))}
			</Slider>
			<div className="mt-5 justify-center z-10 w-full flex md:hidden">
				<button
					ref={buttonPrev}
					aria-label="Previous slide"
					className="hover:opacity-75"
					type="button"
					onClick={gotoPrev}
				>
					<PointLeft size="w-6 h-6" />
				</button>
				<button ref={buttonNext} aria-label="Next slide" className="hover:opacity-75" type="button" onClick={gotoNext}>
					<PointRight size="w-6 h-6" />
				</button>
			</div>

			<div className="flex justify-center mt-10 md:mt-20">
				{buttons &&
					buttons.map(button => (
						<div key={button._uid} className="flex px-2">
							<Button {...(button.props ? button.props : button)} />
						</div>
					))}
			</div>
		</div>
	);
}

compose('carousel', Carousel, { children: ['content'] });

export default Carousel;
